import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as warningPlugin from '../../../warnings/plugin'
import type { TypeParams } from '../../types'

import { Plugin } from './plugin'

/** Factory for record warnings plugin instances. */
export class Factory
  implements
    ec.plugins.Plugin.Factory<
      TypeParams,
      typeof warningPlugin.Plugin.id,
      Plugin
    >
{
  /** @see {@link warningPlugin.Plugin.id} */
  public readonly id = warningPlugin.Plugin.id

  /** @see {@link ec.plugins.Plugin.Factory.produceFor} */
  public produceFor(collection: ec.Collection<TypeParams>): Plugin {
    return new Plugin({ collection })
  }
}
